import { isEmail, isPhone } from "../../utils/validators";

export const getAccountName = (value?: string): string => {
  let username;

  if (value) {
    if (isEmail(value)) {
      username = value.replace("@", "").replace(".", "");
    }

    if (isPhone(value)) {
      username = value.replace("+", "");
    }
  }

  if (!username) {
    throw new Error("Email or Phone are required");
  }

  return `user-${username}`;
};

export const getChildAccountName = (value: string): string =>
  `child-${getAccountName(value)}`;
